$('.js-hamburger').click(function() {
    if ($(this).hasClass('closed')) {
        $(this).removeClass('closed');
        openMenu();
    } else {
        $(this).addClass('closed');
        closeMenu();
    }
})


function openMenu() {
    gsap.to(".hamburger__line-top", { duration: .35, background: "white" });
    gsap.to(".hamburger__arrow-line", { duration: .35, background: "white", width: "75%" });
    gsap.to(".hamburger__line-bottom", { duration: .35, background: "white" });
    gsap.to(".hamburger__arrow-logo", { duration: .35, opacity: 1 });
    gsap.to(".nav", { duration: .5, transform: 'translateY(100vh)', ease: "Power2.easeOut" });
    gsap.to(".main-container", { duration: .5, transform: 'translateY(100vh)', ease: "Power2.easeOut" });
    gsap.to(".main-container", { duration: 0, display: "none", delay: 0.5 });
    gsap.to(".menu-container", { duration: 0, display: "block", zIndex: 0 });
}

function closeMenu() {
    gsap.to(".hamburger__line-top", { duration: .35, background: "#031611" });
    gsap.to(".hamburger__arrow-line", { duration: .35, background: "#031611", width: "100%" });
    gsap.to(".hamburger__line-bottom", { duration: .35, background: "#031611" });
    gsap.to(".hamburger__arrow-logo", { duration: .35, opacity: 0 });
    gsap.fromTo(".nav", {transform: 'translate(100vw, 0vh)' }, { duration: .35, transform: 'translate(0vw, 0vh)', ease: "Power2.easeOut" });
    gsap.to(".main-container", { duration: 0, display: "block" });
    gsap.fromTo(".main-container", {transform: 'translate(100vw, -0.2vh)' }, { duration: .35, transform: 'translate(0vw, -0.2vh)', ease: "Power2.easeOut" });
    gsap.to(".menu-container", { duration: 0, display: "none", zIndex: -1, delay: 0.35 });
}
